exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectedNameText {\n  color: #333333;\n  font-weight: 700;\n}\n.unSelectedNameText {\n  color: #666666;\n  font-weight: 500;\n}\n", ""]);

// exports
